import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      display: 'flex',
      flexFlow: 'row nowrap',
      gap: theme.spacing(1),
    },
    assetIcon: {
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.gray.gray30,
    },
    content: {
      minWidth: 0,
      flex: 1,
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(0.25),
    },
    label: {
      color: COLORS.gray.black,
    },
    body: {
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'MenuItemUrl' }
);
